module.exports = __webpack_public_path__ + "img/oeko-siegel.96c7419b.svg";